/**
 * A polyfilled version of DOMRect.
 *
 * This is only needed to support our current version of Jest, which is using a
 * version of JSDOM prior to v22.1, the first version that introduced support
 * for DOMRect. We can remove this as soon as we update Jest to a modern
 * version.
 */
export type Rect = DOMRect;
export const Rect: typeof DOMRect =
  globalThis.DOMRect ??
  class DOMRect {
    public left: number;
    public top: number;
    public right: number;
    public bottom: number;

    constructor(
      public x: number = 0,
      public y: number = 0,
      public width: number = 0,
      public height: number = 0,
    ) {
      this.left = x;
      this.top = y;
      this.right = x + width;
      this.bottom = y + height;
    }

    static fromRect(rect: DOMRectInit): Rect {
      return new Rect(rect.x, rect.y, rect.width, rect.height);
    }

    toJSON() {
      return {
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        left: this.left,
        top: this.top,
        right: this.right,
        bottom: this.bottom,
      };
    }
  };

// A slimmed-down version of DOMRect.
export interface SimpleRect {
  bottom: number;
  height: number;
  left: number;
  right: number;
  top: number;
  width: number;
}
